
<div class="login-container">
    <div class="login-card">
        <h2>Login</h2>
        <p class="welcome-text">Welcome back! Please enter your details.</p>

        <form [formGroup]="loginForm" (ngSubmit)="login()">

           
            <div class="field">
                <label for="userName">User name</label>
                <div class="input-container">
                    <input
                        id="userName"
                        type="text"
                        pInputText
                        placeholder="Enter username"
                        formControlName="userName"
                        [class.ng-invalid]="loginUserNameControl.invalid && loginUserNameControl.touched"
                        [class.ng-touched]="loginUserNameControl.touched">
                </div>
                <small class="error-text"
                    *ngIf="loginUserNameControl.invalid && loginUserNameControl.touched">
                    Username is required.
                </small>
            </div>

           
            <div class="field">
                <label for="password">Password</label>
                <div class="input-container">
                    <input
                        id="password"
                        [type]="showPassword ? 'text' : 'password'"
                        pInputText
                        placeholder="Enter password"
                        formControlName="password"
                        [class.ng-invalid]="loginPasswordControl.invalid && loginPasswordControl.touched"
                        [class.ng-touched]="loginPasswordControl.touched">
                    <i class="pi password-toggle"
                       [class.pi-eye]="!showPassword"
                       [class.pi-eye-slash]="showPassword"
                       (click)="togglePassword()">
                    </i>
                </div>
                <small class="error-text"
                    *ngIf="loginPasswordControl.invalid && loginPasswordControl.touched">
                    Password is required.
                </small>
            </div>

           
            <div class="api-error" *ngIf="apiError">
                <i class="pi pi-exclamation-circle"></i>
                {{ apiError }}
            </div>

            <div class="actions">
                <button pButton type="submit" label="Login" [loading]="loading"></button>
                <a [routerLink]="[forgotPasswordRoute]">Forgot Password</a>
                <a [routerLink]="[publicPrivacyPolicyRoute]">Privacy Policy</a>
            </div>
        </form>
    </div>
</div>